import styled from 'styled-components';

export const Conteiner = styled.div`
  //flex: content;  
  display: grid; 

  

  > div:not(:last-child) {
    margin-bottom: 1rem;
  }  
  //width: 80rem;
  
  /* > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)) {
    margin-top: 1rem;
  } */  
`;


export const ConteinerInputs = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }

  input {
    text-align: right;
  }
`;

